<template>
  <div class="addLiveInfo">
    <el-card>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="16" :lg="16">
            <el-form-item label="直播名称" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="直播简介" prop="summary">
              <el-input type="textarea" v-model="addForm.summary"></el-input>
            </el-form-item>
            <!-- <el-form-item label="直播场景" prop="scene" class="live">
              <el-radio v-model="addForm.scene" :label="1">
                <div class="liveType">普通直播(纯视频)</div>
              </el-radio>
              <el-radio v-model="addForm.scene" :label="2">
                <div class="liveType">云课堂(三分频)</div>
              </el-radio>
            </el-form-item>-->
            <el-form-item label="封面" prop="cover">
              <div v-if="image==null" class="upload_type el-icon-plus" @click="photoMaterialVisible = true"></div>
              <div v-else @click="photoMaterialVisible = true">
                <img class="upload_type_img" width="140" height="100" :src="image" />
              </div>
              <div class="small_text">建议：上传尺寸为750*560的PNG、JPG图片，大小不超过1M</div>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始时间" prop="beginTime">
                  <el-date-picker style="width:100%" v-model="addForm.beginTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="直播时长" prop="liveDuration">
                  <el-select style="width:100%" v-model="addForm.liveDuration">
                    <el-option v-for="(item,index) in timeList" :key="index" :label="item.name" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="进入方式" prop="watchType">
              <el-radio v-model="addForm.watchType" :label="1">免费</el-radio>
              <el-radio v-model="addForm.watchType" :label="2">加密</el-radio>
              <div class="flex-starts" style="display:initial" v-if="addForm.watchType==2">
                <el-input v-model="addForm.watchPassword" style="width:200px" placeholder="请输入密码" maxlength="6"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="直播室密码" prop="channelPassword">
              <el-input v-model="addForm.channelPassword" placeholder="请输入直播间密码" maxlength="6">免费</el-input>
            </el-form-item>
            <el-form-item label="关联课程" prop="courseId">
              <el-cascader style="width:100%" clearable v-model="addForm.courseId" :empty="addForm.subjectCourseName" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择关联课程" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="直播详情" prop="detail">
              <div style="background: #FFF" v-if="showUe">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
            <!-- <el-form-item label="防录屏跑马灯" prop="marquee">
              <el-switch v-model="addForm.marquee" :active-value="1" :inactive-value="-1" class="switchStyle2" active-text="开" inactive-text="关"></el-switch>
            </el-form-item> -->
            <el-form-item label="防录屏跑马灯" prop="marquee">
              <el-switch v-model="addForm.marquee" :active-value="1" :inactive-value="-1" class="switchStyle2" active-text="开" inactive-text="关"></el-switch>
            </el-form-item>
            <el-form-item label="回放设置" prop="replay">
              <el-switch v-model="addForm.replay" :active-value="1" :inactive-value="-1" class="switchStyle2" active-text="开" inactive-text="关"></el-switch>
            </el-form-item>
            <el-form-item label="最大观看人数" prop="maxViewer">
              <el-input v-model="addForm.maxViewer"></el-input>
              最大观看人数不超过2000人
            </el-form-item>
            <el-form-item label="观看次数" prop="countWatch">
              <el-input v-model="addForm.countWatch" type="number" min="0"></el-input>
            </el-form-item>
            <el-form-item label="点赞次数" prop="countLike">
              <el-input v-model="addForm.countLike" type="number" min="0"></el-input>
            </el-form-item>
            <el-form-item label="pc端观看地址" >
              <el-input v-model="addForm.pcViewUrl" readonly="true"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否登陆观看" prop="hasLogin">
              <el-switch v-model="addForm.hasLogin" :active-value="1" :inactive-value="0" class="switchStyle2" active-text="是" inactive-text="否"></el-switch>
            </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
      <div style="margin-left:90px">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" @click="createChannel" :loading="createChannelBlock">提交</el-button>
      </div>
    </el-card>
    <el-dialog title="添加" :visible.sync="photoMaterialVisible" width="800px" :close-on-click-modal="false">
      <photoMaterial @photoChange="photoChange"></photoMaterial>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UE from "../conmom/CKEditorInformation.vue";
import photoMaterial from "../common/photoMaterial.vue";
import draggable from "vuedraggable";
export default {
  components: { UE, draggable, photoMaterial },
  data () {
    return {
      createChannelBlock: false,
      photoMaterialVisible: false,
      showUe: true,
      ueTtext: "",
      timeList: [
        { key: 1, name: "1小时" },
        { key: 2, name: "2小时" },
        { key: 3, name: "3小时" },
        { key: 4, name: "4小时" },
      ],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      addForm: {
        name: null,
        summary: null,
        scene: 1,
        cover: null,
        beginTime: null,
        liveDuration: null,
        watchType: 1,
        watchPassword: null,
        channelPassword: null,
        courseId: null,
        detail: null,
        marquee: 1,
        replay: 1,
        // hasLogin: 1,
        maxViewer: 1,
        publisher: null,
        countWatch: 0,
        countLike: 0,
        pcViewUrl:null
      },
      formLabelWidth: "90px",
      addFormRules: {
        name: {
          required: true,
          message: "请输入直播名称",
          trigger: "blur",
        },
        summary: {
          required: true,
          message: "请输入直播简介",
          trigger: "blur",
        },
        scene: {
          required: true,
          message: "请选择直播场景",
          trigger: "change",
        },
        cover: {
          required: true,
          message: "请上传封面",
          trigger: "change",
        },
        beginTime: {
          required: true,
          message: "请选择开始时间",
          trigger: "change",
        },

        liveDuration: {
          required: true,
          message: "请选择直播时长",
          trigger: "change",
        },
        watchType: {
          required: true,
          message: "请选择进入方式",
          trigger: "change",
        },
        channelPassword: [
          {
            required: true,
            message: "请输入直播间密码",
            trigger: "blur",
          },
          {
            pattern: /^\d{6}$/,
            message: "直播间密码为6位数字",
          },
        ],
        courseId: {
          required: true,
          message: "请选择关联课程",
          trigger: "change",
        },
      },
      image: null,
    };
  },
  watch: {},
  methods: {
    /*-------------------------------------------上传图片--------------------------------------- */
    photoChange (val) {
      this.addForm.cover = val[0].id;
      this.image = val[0].url;
      this.photoMaterialVisible = false;
    },

    /*-------------------------------------------数据修改--------------------------------------- */
    //返回
    goBack () {
      this.$router.go(-1);
    },

    //提交
    createChannel () {
      if (this.createChannelBlock) {
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.watchType == 2) {
            if (
              this.addForm.watchPassword == null ||
              this.addForm.watchPassword == ""
            ) {
              this.$message.error("请输入密码！");
              return;
            }
          }
          this.createChannelBlock = true;
          this.addForm.detail = this.$refs.myQuillEditorTitle._data.content;
          if (!this.addForm.detail) { this.$message.warning('请输入直播详情'); this.createChannelBlock = false; return; }
          if (this.addForm.detail.length > 1000) { this.$message.warning('直播详情不能多余1000字'); this.createChannelBlock = false; return; }
          if (typeof this.addForm.courseId == "object") {
            let len = this.addForm.courseId.length;
            this.addForm.courseId = this.addForm.courseId[len];
          }
          this.api.polyvChannel
            .updatePolyvChannel(this.addForm)
            .then((result) => {
              if (result.success) {
                this.createChannelBlock = false;
                this.$router.push({ path: "/liveList" });
              } else {
                this.$message.error(result.message);
              }
            });
        }
      });
    },

    subjectSearchChange () {
      // if (this.courseIds) {
      //   this.addForm.subjectId = this.courseIds[1];
      // } else {
      //   this.searchForm.subjectId = "";
      // }
    },
    /*-------------------------------------------获取数据--------------------------------------- */

    //获取直播数据
    getPolyvChannel () {
      this.showUe = false;
      this.api.polyvChannel
        .getPolyvChannel({ id: this.$route.query.id })
        .then((result) => {
          if (result.success) {
            this.addForm = result.data;
            this.ueTtext = this.addForm.detail;
            this.image = result.data.coverUrl;
            this.showUe = true;
          } else {
            this.$message.error(result.message);
          }
        });
    },

    // 获取课程
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                }
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取6位随机数
    getRandom () {
      let Num = "";
      for (var i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      this.addForm.channelPassword = Num;
    },
  },
  computed: {},
  mounted () {
    this.getPolyvChannel();
    this.getSubjectTreeList();
  },
};
</script>
<style lang="less">
.addLiveInfo {
  .live {
    .el-radio__input {
      display: none !important;
    }
  }
  .liveType {
    height: 100px;
    width: 140px;
    border: 1px solid rgba(238, 238, 238, 1);
    text-align: center;
    line-height: 100px;
    border-radius: 6px;
  }
  .liveType:hover {
    border-color: #409eff;
    color: #409eff;
  }
  .el-radio__input.is-checked + .el-radio__label {
    .liveType {
      border-color: #409eff;
    }
  }
  .upload_type {
    width: 140px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    line-height: 140px;
    text-align: center;
    line-height: 100px;
    font-size: 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  .upload_type_img {
    width: 140px;
    height: 100px;
    line-height: 140px;
    text-align: center;
    line-height: 100px;
    font-size: 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  .upload_type:hover {
    color: #409eff;
    border-color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveInfo/editLiveInfo.vue